import { useCallback, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import Alert from "react-bootstrap/Alert";

import Api from "../../../../services/Api";
import useAuth from "../../../../routes/login/AuthContext";

export const TagRemovalModal = ({ state, setData, onSuccess }) => {
  const { name, id } = state || {};
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);

  const { getAuthToken } = useAuth();
  const onClose = useCallback(() => {
    setData(null);
    setError(false);
    setLoading(false);
  }, []);
  const onRemove = useCallback(async () => {
    setLoading(true);
    const success = await Api.removeTag(id, await getAuthToken());

    if (success) {
      onSuccess(id);
    } else {
      setError(true);
    }

    setLoading(false);
  }, [id, getAuthToken]);

  return (
    <Modal show={id >= 0} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Confirm Tag Removal</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        {error ? <Alert variant="danger">An error occurred while removing tag</Alert> : null}

        <p>Tag to Remove: {name}</p>
      </Modal.Body>

      <Modal.Footer>
        {loading ? <Spinner variant="primary" size="sm" animation="border" /> : null}
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="primary" onClick={onRemove}>
          Remove Tag
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
